/**
 * VarietyDropdownSearch Selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// Selectors
import { selectVarieties } from '../../../../services/varieties/selectors';
import { selectCommodities } from '../../../../services/commodities/selectors';

// Utils
import orderBy from '../../../../utils/custom-orderBy';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectVarietyData = createDeepEqualSelector(
    selectVarieties,
    varietiesState => varietiesState && Object.values(varietiesState)
);

const selectCommodityData = createDeepEqualSelector(
    selectCommodities,
    commoditiesState => commoditiesState && Object.values(commoditiesState)
);

const selectVarietiesWithCommodityName = createDeepEqualSelector(
    [selectVarietyData, selectCommodityData],
    (orderedVarietiesState, commodityDataState) =>
        orderedVarietiesState.map(variety => {
            const commodity = commodityDataState.filter(
                commodity => variety.commodityId === commodity.id
            );

            return {
                ...variety,
                // If the variety name is null then it must be a Generic variety of that commodity
                name: variety.name || `Generic - ${commodity[0].name}`,
                _commodityName: commodity[0].name
            };
        })
);

const selectFilteredData = createDeepEqualSelector(
    selectVarietiesWithCommodityName,
    varietiesWithCommodityNameState => varietiesWithCommodityNameState
);

const selectOrderedData = createDeepEqualSelector(
    selectFilteredData,
    filteredDataState => orderBy(filteredDataState, 'name')
);

const selectOptions = createDeepEqualSelector(
    selectOrderedData,
    orderedDataState =>
        orderedDataState.map(({ id, name }) => ({
            key: id,
            text: name,
            value: `${id}`
        }))
);

export { selectOptions };
